import { PropsWithChildren, useCallback, useState } from "react";
import GenericFlyout from "../modal/GenericFlyout";
import Icon from "../Icon";
import { useBjelinTranslations } from "../../hooks/TranslationHooks";

const MobileMenu = ({ children }: PropsWithChildren<void>) => {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const closeMobileMenu = useCallback(() => {
    setShowMobileMenu(false);
  }, []);
  const toggleMobileMenu = useCallback(() => {
    setShowMobileMenu(showMobileMenu => !showMobileMenu);
  }, []);
  const t = useBjelinTranslations();

  return (
    <>
      <button
        id="mobile-menu-button"
        aria-haspopup="dialog"
        aria-label={t("menu")}
        className="nav-link"
        style={{
          backgroundColor: showMobileMenu ? "#fff" : "transparent",
          border: 0
        }}
        aria-expanded={showMobileMenu}
        onClick={toggleMobileMenu}
      >
        <Icon name="bars" className="icon" />
      </button>

      <GenericFlyout
        id="mobile-menu-dropdown"
        isOpen={showMobileMenu}
        close={closeMobileMenu}
        minHeight={19.4}
        noCloseBtn
        align={"top"}
        ariaLabel={t("menu")}
      >
        <div className="mobile-menu">{children}</div>
      </GenericFlyout>
    </>
  );
};

export default MobileMenu;
